module.exports = __webpack_public_path__ + "img/cr.41a8307b.svg";